import * as Immutable from "immutable";
import { SearchDecorators } from "@graylog/server-api";
import View from "./View";
import ViewState from "./ViewState";
import { resultHistogram, allMessagesTable } from "../Widgets";
import WidgetPosition from "../widgets/WidgetPosition";
export const matchesDecoratorStream = (streamId) => {
  if (!streamId) {
    return ({ stream }) => stream === null;
  }
  if (streamId instanceof Array) {
    return ({ stream }) => streamId.includes(stream);
  }
  return ({ stream }) => stream === streamId;
};
export const matchesDecoratorStreamCategories = (streamCategory) => {
  if (!streamCategory) {
    return ({ category }) => category === null;
  }
  if (streamCategory instanceof Array) {
    return ({ category }) => streamCategory.includes(category);
  }
  return ({ category }) => category === streamCategory;
};
const _defaultWidgets = {
  [View.Type.Search]: async (streamId, streamCategory) => {
    const decorators = await SearchDecorators.get();
    const byStreamId = matchesDecoratorStream(streamId);
    const byStreamCategory = matchesDecoratorStreamCategories(streamCategory);
    const streamDecorators = decorators ? decorators.filter(byStreamId) : [];
    const streamCategoryDecorators = (decorators == null ? void 0 : decorators.length) ? decorators.filter(byStreamCategory) : [];
    const allDecorators = (
      // eslint-disable-next-line no-nested-ternary
      streamDecorators.length && streamCategoryDecorators.length ? [...streamDecorators, ...streamCategoryDecorators] : streamDecorators.length ? streamDecorators : streamCategoryDecorators
    );
    const histogram = resultHistogram();
    const messageTable = allMessagesTable(void 0, allDecorators);
    const widgets = [histogram, messageTable];
    const titles = {
      widget: {
        [histogram.id]: "Message Count",
        [messageTable.id]: "All Messages"
      }
    };
    const positions = {
      [histogram.id]: new WidgetPosition(1, 1, 2, Infinity),
      [messageTable.id]: new WidgetPosition(1, 3, 6, Infinity)
    };
    return { titles, widgets, positions };
  },
  [View.Type.Dashboard]: async (_streamId) => {
    const widgets = [];
    const titles = {};
    const positions = {};
    return { titles, widgets, positions };
  }
};
export default async (type, streamId, streamCategory) => {
  const { titles, widgets, positions } = await _defaultWidgets[type](streamId, streamCategory);
  return ViewState.create().toBuilder().titles(titles).widgets(Immutable.List(widgets)).widgetPositions(positions).build();
};
